import {
  Confirm,
  Datagrid,
  List,
  TextField,
  useDataProvider,
  useNotify,
  useRecordContext,
  useRefresh,
  useTranslate,
  WrapperField,
  TopToolbar,
} from 'react-admin';
import { useMutation } from 'react-query';
import { useState } from 'react';
import {Button, IconButton} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import * as React from "react";
import ContentAdd from "@mui/icons-material/Add";
import {Link} from "react-router-dom";

const CancelCouponButton = () => {
  const record = useRecordContext();
  const refresh = useRefresh();
  const notify = useNotify();
  const translate = useTranslate();
  const [open, setOpen] = useState(false);
  const dataProvider = useDataProvider();
  const { mutate, isLoading } = useMutation(() =>
    dataProvider.cancelOpeningHour(record, dataProvider).then((data: any) => {
      if (data.id) {
        notify('app.show.locations.tabs.opening_hours.actions.cancelled', {
          type: 'success',
          messageArgs: { smart_count: 1 },
        });
        refresh();
      } else {
        notify(data.detail, {
          type: 'error',
          messageArgs: { smart_count: 1 },
        });
        refresh();
      }
    }).catch(() => {
      notify('Error', {
        type: 'error',
        messageArgs: { smart_count: 1 },
      });
    })
  );
  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);
  const handleConfirm = () => {
    mutate();
    setOpen(false);
  };
  let modalContent = translate('app.show.locations.tabs.opening_hours.actions.modal.content');

  return (
    <>
      <IconButton
        aria-label="Example"
        onClick={handleClick}
        disabled={isLoading}
        style={{paddingLeft: '0px'}}
      >
        <DeleteOutlineIcon />
      </IconButton>
      <Confirm
        isOpen={open}
        loading={isLoading}
        title={'app.show.locations.tabs.opening_hours.actions.modal.title'}
        content={modalContent}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};

const EditCouponButton = () => {
  const record = useRecordContext();

  return (
    <IconButton
      component={Link}
      to={{
        pathname: '/admin/opening_hours/' + encodeURIComponent(record.id),
      }}
      state={{ record: { 'location': record } }}
    >
      <EditIcon />
    </IconButton>
  );
};

const LocationOpeningHours = () => {
  const record = useRecordContext();
  const translate = useTranslate();

  if (!record) return null;

  return (
    <>
      <TopToolbar>
        <Button
          startIcon={<ContentAdd />}
          component={Link}
          to={{
            pathname: '/admin/opening_hours/create',
          }}
          state={{ record: { 'location': record } }}
        >
          {translate('app.show.locations.tabs.opening_hours.actions.create')}
        </Button>
      </TopToolbar>
      <List
        resource={'admin/opening_hours'}
        exporter={false}
        actions={false}
        filter={{ location: record.id }}
        title={<>{translate('app.show.locations.tabs.opening_hours.title')}</>}
        hasCreate={false}
      >
        <Datagrid
          bulkActionButtons={false}
          sx={{
            '& .RaDatagrid-headerCell': {
              backgroundColor: '#eee',
              fontWeight: 'bold',
              fontSize: '1rem',
            },
          }}
        >
          <TextField
            source={'name'}
            label={'app.show.locations.tabs.opening_hours.table.name'}
          />
          <WrapperField
            label={'app.show.locations.tabs.opening_hours.table.action'}
          >
            <div style={{display: 'flex'}}>
              <CancelCouponButton />
              <EditCouponButton />
            </div>
          </WrapperField>
        </Datagrid>
      </List>
    </>
  );
};

export default LocationOpeningHours;
